import { createContext, useEffect, useRef, useState } from 'react';
import { Optional, Preset } from '../../../types/types';

export const PresetContext = createContext<Preset>(Preset.CALENDAR_PAGE);

export const PresetConsumer = PresetContext.Consumer;
export const PresetProvider = PresetContext.Provider;

export const useCreateCssVarsClassContainer = () => {
  const rootRef = useRef<HTMLDivElement>(null);
  const [cssVarsContainerClassName, setCssVarsContainerClassName] =
    useState<Optional<string>>(undefined);

  useEffect(() => {
    if (rootRef.current) {
      const calendarWrapper = rootRef.current.closest(
        '[data-hook="BookingCalendar-wrapper"]',
      );
      if (calendarWrapper?.parentElement) {
        setCssVarsContainerClassName(calendarWrapper?.parentElement.className);
      }
    }
  }, []);

  return { rootRef, cssVarsContainerClassName };
};
